import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent, ToasterComponent } from '@aksia/ui';
import { LAYOUT_SERVICE_TOKEN } from '@aksia/infrastructure';
@Component({
  standalone: true,
  imports: [RouterModule, PageLayoutComponent, ToasterComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  protected title = 'oauth';

  protected readonly layout = inject(LAYOUT_SERVICE_TOKEN);
}
